import { Link } from "react-router-dom";
import NewsletterForm from "@/components/feature/NewsletterForm";
import {
  CORRECTION_EMAIL,
  SITE_EMAIL,
  SITE_NAME,
  SITE_TAGLINE,
  filterCategories,
} from "@/lib/site";

const linkGroups = [
  {
    title: "站内导航",
    links: [
      { label: "首页", to: "/" },
      { label: "话题档案", to: "/topics" },
      { label: "常见问题", to: "/faq" },
      { label: "关于我们", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[1.5fr_1fr_1fr_1.8fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{SITE_NAME}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/75">
              把零散的爆料、回应与澄清按时间重新排成一条能读下去的线，让「到底发生了什么」有据可查。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-background-50/15 px-3 py-1 text-xs text-background-100/80">
              <i className="ri-radar-line text-primary-300" aria-hidden="true" />
              {SITE_TAGLINE}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">话题分类</h3>
            <ul className="mt-4 space-y-2">
              {filterCategories.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/topics?cat=${item.id}`}
                    className="text-sm text-background-100/75 transition-colors hover:text-primary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-semibold text-background-50">{group.title}</h3>
              <ul className="mt-4 space-y-2">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-100/75 transition-colors hover:text-primary-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div id="subscribe" className="scroll-mt-28">
            <NewsletterForm />
            <div className="mt-6 space-y-2 border-t border-background-50/10 pt-4 text-xs text-background-100/70">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line" aria-hidden="true" />
                <a href={`mailto:${SITE_EMAIL}`} className="hover:text-primary-300">
                  {SITE_EMAIL}
                </a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-error-warning-line" aria-hidden="true" />
                <a href={`mailto:${CORRECTION_EMAIL}`} className="hover:text-primary-300">
                  内容纠错：{CORRECTION_EMAIL}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10 px-4 py-5 md:px-8">
        <div className="flex flex-col gap-3 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {SITE_NAME}. 保留所有权利。</p>
          <p className="max-w-2xl leading-relaxed">
            本站内容均为公开信息的整理与时间线复盘，只呈现事件脉络与信息来源类型，不对任何主体作出评价或定性。
          </p>
        </div>
      </div>
    </footer>
  );
}